import React from "react";

/* Switch / toggle — track turns green when on. */
const SIZES = { sm: { w: 36, h: 20, k: 14 }, md: { w: 44, h: 24, k: 18 } };

export function Switch({ checked = false, onChange, label, disabled = false, size = "md", style, ...rest }) {
  const s = SIZES[size] || SIZES.md;
  const [focused, setFocused] = React.useState(false);
  return (
    <label
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        fontFamily: "var(--font-sans)",
        fontWeight: 500,
        fontSize: 14,
        color: "var(--text-body)",
        ...style,
        // Layout is structural, not cosmetic — never let caller `style` collapse the track/label gap.
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
      }}
      {...rest}
    >
      <span
        style={{
          position: "relative",
          width: s.w,
          height: s.h,
          flex: "none",
          borderRadius: "var(--radius-pill)",
          background: checked ? "var(--green-bright)" : "var(--grey-mid)",
          transition: "background var(--dur) var(--ease)",
          // Focus ring — the only focusable node is the opacity:0 input, so surface
          // keyboard focus on the visible track (WCAG 2.4.7).
          boxShadow: focused ? "0 0 0 2px var(--surface-card), 0 0 0 4px var(--green-bright)" : "none",
        }}
      >
        {/* Hidden checkbox drives accessibility (role=checkbox, checked state, keyboard). */}
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => !disabled && onChange && onChange(e.target.checked)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            opacity: 0,
            cursor: disabled ? "not-allowed" : "pointer",
            margin: 0,
            zIndex: 1,
          }}
        />
        <span
          style={{
            position: "absolute",
            top: (s.h - s.k) / 2,
            left: checked ? s.w - s.k - (s.h - s.k) / 2 : (s.h - s.k) / 2,
            width: s.k,
            height: s.k,
            borderRadius: "50%",
            background: "var(--white)",
            boxShadow: "0 1px 2px rgba(0,0,0,0.25)",
            transition: "left var(--dur) var(--ease)",
          }}
        />
      </span>
      {label ? <span>{label}</span> : null}
    </label>
  );
}

export default Switch;
